import CitySEOHead from "@/components/feature/CitySEOHead";
import MetairieHeroSection from "./components/HeroSection";
import MetairieStickyNav from "./components/StickyNav";
import MetairieProcessingTimeSection from "./components/ProcessingTimeSection";
import MetairieServicesSection from "./components/ServicesSection";
import MetairieLocalAreaSection from "./components/LocalAreaSection";
import MetairieTestimonialsSection from "./components/TestimonialsSection";
import MetairieAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MetairieComparisonSection from "./components/ComparisonSection";
import MetairieMistakesSection from "./components/MistakesSection";
import MetairieHowItWorksSection from "./components/HowItWorksSection";
import MetairieFAQSection, { faqs } from "./components/FAQSection";
import MetairieHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MetairieFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import MetairieTravelTimingSection from "./components/TravelTimingSection";
import MetairieDestinationsSection from "./components/DestinationsSection";

export default function MetairiePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Metairie"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/metairie"
        title="Emergency Passport Metairie, LA — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Metairie, LA — as fast as 24 hours. Serving Lakeside professionals, Elmwood executives, and Jefferson Parish families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Metairie, Louisiana"
        geoPosition="29.9841;-90.1529"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <MetairieHeroSection />
      <MetairieStickyNav />
      <MetairieProcessingTimeSection />
      <MetairieServicesSection />
      <MetairieLocalAreaSection />
      <MetairieTravelTimingSection />
      <MetairieDestinationsSection />
      <MetairieTestimonialsSection />
      <MetairieAcceptanceFacilitiesSection />
      <MetairieComparisonSection />
      <MetairieMistakesSection />
      <MetairieHowItWorksSection />
      <MetairieFAQSection />
      <MetairieHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/metairie" state="LA" />
      <MetairieFinalCTA />
    </div>
  );
}